module.exports = __webpack_public_path__ + "static/media/hi-black.3978a822.svg";